import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const SIM_STORE_KEY = "assertimmo_sim";
export const ADMIN_TOKEN_KEY = "assertimmo_admin_session";
export const UNLOCK_KEY = "assertimmo_unlocked";

export const saveSim = (data) => {
  sessionStorage.removeItem("assertimmo_tracked");
  sessionStorage.removeItem(UNLOCK_KEY);
  sessionStorage.setItem(SIM_STORE_KEY, JSON.stringify(data));
};

export const loadSim = () => {
  try {
    return JSON.parse(sessionStorage.getItem(SIM_STORE_KEY));
  } catch {
    return null;
  }
};
